import { useState } from "react";
import { useTranslation } from "react-i18next";
import { getClassesByInstance } from "../../../../services/classService";
import { ClassData } from "../../../../types/classTypes";
import { useSelector } from "react-redux";

const useClassTeacher = () => {
  const { t } = useTranslation();
  const [classes, setClasses] = useState<ClassData[]>([]);
  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 10,
    total: 0,
  });
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const teacherId = useSelector((state: any) => state.authSlice.user?.roleId);



  const fetchTeacherClasses = async (parames: any) => {
    setLoading(true);
    try {
      const response = await getClassesByInstance({ ...parames, teacherId });
      setClasses(response.data);
      setPagination(response.pagination);
      setLoading(false);
    } catch (error) {
      setClasses([])
      setError(t("errors.ERROR_FETCHING_DATA"))
    } finally {
      setLoading(false);
    }
  };


  return {
    loading,
    fetchTeacherClasses,
    pagination,
    classes,
    error
  };
};

export default useClassTeacher;
